import type { RouteRecordRaw } from 'vue-router'

export const marketsRoutes: RouteRecordRaw[] = [
  {
    path: '/masters/markets',
    name: 'MARKETS',
    component: () => import('./MarketsPage.vue'),
    meta: { requiresAuth: true, permission: 'super_admin' },
  },
]
